"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWithSpinner = void 0;
const react_1 = __importDefault(require("react"));
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const styled_components_1 = require("../common/styles/styled-components");
exports.ButtonWithSpinner = react_1.default.forwardRef((_a, ref) => {
    var { mode = 'primary', showSpinner = false, children, disabled, onClick } = _a, props = __rest(_a, ["mode", "showSpinner", "children", "disabled", "onClick"]);
    const spinnerColor = 'currentColor';
    const buttonProps = Object.assign(Object.assign({}, props), { showSpinner,
        disabled, onClick: disabled ? undefined : onClick, ref });
    switch (mode) {
        case 'secondary':
            return (react_1.default.createElement(styled_components_1.SecondaryButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'tertiary':
            return (react_1.default.createElement(styled_components_1.TertiaryButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'quaternary':
            return (react_1.default.createElement(styled_components_1.QuaternaryButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'flat':
            return (react_1.default.createElement(styled_components_1.FlatButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'ghost':
            return (react_1.default.createElement(styled_components_1.GhostButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'contrast':
            return (react_1.default.createElement(styled_components_1.ContrastButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'floating-primary':
            return (react_1.default.createElement(styled_components_1.FloatingPrimaryButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'primary':
        default:
            return (react_1.default.createElement(styled_components_1.PrimaryButtonWithSpinner, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
    }
});
exports.ButtonWithSpinner.displayName = 'ButtonWithSpinner';
//# sourceMappingURL=ButtonWithSpinner.js.map